define("shared/utils/create-oauth-popup", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.createOAuthPopup = createOAuthPopup;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  /**
   * Helper function for creating an popup for guiding users through supported
   * authentication flows via backend server.
   * @param args
   * @returns Popup instance
   */
  function createOAuthPopup(args) {
    const {
      groupId,
      socialProfileId
    } = args;
    const oAuthPopupName = `${args.oAuthSocialProfileType}_oauth`;
    const oAuthPath = args.connectProfiles.oAuthPath({
      socialProfileType: args.oAuthSocialProfileType,
      redirectPath: args.router.urlFor('user.profile-refresh-popup', oAuthPopupName).slice(1)
    });
    const oAuthUrl = `${oAuthPath}&group_id=${groupId}&refresh_social_profile_id=${socialProfileId}`;
    return args.popupManager.createPopup(oAuthPopupName, {
      url: oAuthUrl
    });
  }
});